/** @format */

import {Text} from 'recharts';

import {ScatterPointItem} from 'recharts/types/cartesian/Scatter';

import {CommonChartData} from '../../model/charts';
import {X_ADJUST, X_TEXT_ADJUST, Y_ADJUST, Y_TEXT_ADJUST} from './constants';

type Props = ScatterPointItem & {
  payload?: CommonChartData;
};

const isCommonChartData = (payload: unknown): payload is CommonChartData => {
  return (payload as CommonChartData)?.primary !== undefined;
};

const Shape = ({cx = 0, payload}: Props) => {
  if (!payload || !isCommonChartData(payload) || payload.hide) {
    return null;
  }

  const IconComponent = payload.scatterOptions?.IconComponent;

  if (IconComponent) {
    return (
      <foreignObject x={cx + X_ADJUST} y={Y_ADJUST} width={32} height={32} overflow='visible'>
        {IconComponent}
      </foreignObject>
    );
  }

  return (
    <Text x={cx + X_TEXT_ADJUST} y={Y_TEXT_ADJUST}>
      {String(payload.primary)}
    </Text>
  );
};

export {Shape};
